import coreClient from "../coreClient";

export function getDailyQuests(userId: string){
    return coreClient.get(`/Quests/Daily?UserId=${userId}`)
}

export function getQuests(userId: string){
    return coreClient.get(`/Quests`)
}